import React, { createContext, useContext, useState, useEffect } from 'react';
import { getAccessToken } from '../authUtils';

type Role = 'developer' | 'audit';

interface UserContextValue {
  role: Role;
  loading: boolean;
}

const UserContext = createContext<UserContextValue>({
  role: 'audit',
  loading: true,
});

export const UserProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [role, setRole] = useState<Role>('audit');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const baseUrl = import.meta.env.VITE_API_URL ?? '';
    getAccessToken().then(token => {
      if (!token) {
        setLoading(false);
        return;
      }
      fetch(`${baseUrl}/api/auth/me`, {
        headers: { Authorization: `Bearer ${token}` }
      })
        .then(r => r.json())
        .then(data => {
          if (data.role === 'developer' || data.role === 'audit') {
            setRole(data.role);
          }
        })
        .catch(() => {})
        .finally(() => setLoading(false));
    });
  }, []);

  return (
    <UserContext.Provider value={{ role, loading }}>
      {children}
    </UserContext.Provider>
  );
};

export function useRole(): UserContextValue {
  return useContext(UserContext);
}
